// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/contact-details/total-invoiced.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/icons/contact-details/paid.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/icons/contact-details/outstanding.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contact Details Styling - Pixel-Perfect Figma Implementation (1564:164698, 1587:89228, 1581:149550, 1591:150629, 1591:150817, 1591:151005) */

.contact-details-page {
  display: flex;
  min-height: 100vh;
  background-color: var(--bg-primary, #f4f7f7);
  color: var(--text-primary, #142624);
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  box-sizing: border-box;
}

.contact-details-page .dashboard-main {
  flex: 1 1;
  min-width: 0;
  margin-left: 256px;
  display: flex;
  flex-direction: column;
}

.contact-details-content {
  padding: 32px 32px 48px;
  max-width: 100%;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
}

/* Header & Back Link */
.contact-details-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.contact-details-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 12px;
  border-radius: 10px;
  background: transparent;
  color: var(--interactive-default, #0f766e);
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.15s ease;
  width: -moz-fit-content;
  width: fit-content;
}

.contact-details-back-btn:hover {
  background-color: var(--interactive-soft, #f0f8f7);
}

.contact-details-back-btn svg {
  font-size: 16px;
}

.contact-details-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.contact-details-identity {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contact-details-title {
  margin: 0;
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.48px;
  color: var(--text-primary, #142624);
}

.contact-details-badges {
  display: flex;
  align-items: center;
  gap: 8px;
}

.contact-badge-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  background-color: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}

.contact-badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--interactive-default, #0f766e);
}

.contact-badge-pill.status-archived {
  background-color: var(--surface-tertiary, #e8edec);
  color: var(--text-secondary, #506360);
}

.contact-badge-pill.status-archived .contact-badge-dot {
  background-color: var(--text-disabled, #8a9896);
}

/* Header Actions */
.contact-details-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}

.contact-btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  border: 1px solid var(--border-default, #cdd6d4);
  background-color: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.contact-btn-secondary:hover {
  background-color: var(--surface-tertiary, #e8edec);
  border-color: var(--border-strong, #8b9996);
  color: var(--text-primary, #142624);
}

.contact-btn-primary,
.contact-btn-primary:link,
.contact-btn-primary:visited {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  border: none;
  background-color: var(--interactive-default, #0f766e);
  color: #ffffff !important;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.15s ease;
}

.contact-btn-primary:hover {
  background-color: var(--interactive-hover, #0a655f);
  color: #ffffff !important;
}

.contact-btn-primary:active {
  background-color: var(--interactive-pressed, #084f4b);
  color: #ffffff !important;
}

.contact-btn-primary svg {
  color: #ffffff !important;
  stroke: #ffffff !important;
}

/* Dark mode button themes */
.contact-details-page.dark .contact-btn-primary,
.contact-details-page[data-theme="dark"] .contact-btn-primary {
  background-color: var(--interactive-default, #43a79c);
  color: #101113 !important;
  font-weight: 600;
}

.contact-details-page.dark .contact-btn-primary svg,
.contact-details-page[data-theme="dark"] .contact-btn-primary svg {
  color: #101113 !important;
  stroke: #101113 !important;
}

.contact-details-page.dark .contact-btn-primary:hover,
.contact-details-page[data-theme="dark"] .contact-btn-primary:hover {
  background-color: var(--interactive-hover, #83c7be);
  color: #101113 !important;
}

.contact-details-page.dark .contact-btn-primary:active,
.contact-details-page[data-theme="dark"] .contact-btn-primary:active {
  background-color: var(--interactive-pressed, #b6ded8);
  color: #101113 !important;
}

.contact-details-page.dark .contact-btn-secondary {
  background-color: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.contact-details-page.dark .contact-btn-secondary:hover,
.contact-details-page[data-theme="dark"] .contact-btn-secondary:hover {
  background-color: var(--surface-tertiary, #2b2f35);
  border-color: var(--border-strong, #69727e);
  color: var(--text-primary, #f2f3f5);
}

/* More Dropdown Menu */
.contact-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 120px;
  min-width: 200px;
  background: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 50;
  overflow: hidden;
  padding: 4px 0;
}

.contact-dropdown-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border: none;
  background: transparent;
  color: var(--text-primary, #142624);
  font-size: 13px;
  font-weight: 400;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.contact-dropdown-item:hover {
  background-color: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}

.contact-dropdown-item.danger:hover {
  background-color: var(--danger-soft, #fef2f1);
  color: var(--danger-default, #c23a2b);
}

/* Tabs */
.contact-details-tabs {
  display: flex;
  align-items: flex-end;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  margin-bottom: 24px;
  gap: 4px;
}

.contact-tab-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 400;
  color: var(--text-secondary, #506360);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.15s ease;
}

.contact-tab-btn:hover {
  color: var(--text-primary, #142624);
}

.contact-tab-btn.active {
  color: var(--interactive-default, #0f766e);
  font-weight: 500;
  border-bottom: 2px solid var(--interactive-default, #0f766e);
}

/* Stat Cards (3 Cards Row) */
.contact-stat-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 24px;
}

.contact-stat-card {
  background-color: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  padding: 24px;
  min-height: 154px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}

.contact-stat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.contact-stat-title {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
  color: var(--text-primary, #142624);
}

.contact-stat-icon {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  color: var(--interactive-default, #0f766e);
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-stat-icon svg {
  width: 20px;
  height: 20px;
  display: block;
  stroke: currentColor;
}

.contact-stat-icon--figma::before {
  content: "";
  display: block;
  width: 20px;
  height: 20px;
  background-color: currentColor;
  mask: var(--contact-stat-icon-source) center / 20px 20px no-repeat;
}

.contact-stat-icon--total-invoiced {
  --contact-stat-icon-source: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.contact-stat-icon--paid {
  --contact-stat-icon-source: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.contact-stat-icon--outstanding {
  --contact-stat-icon-source: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.contact-stat-headline {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contact-stat-amount {
  margin: 0;
  font-family: "JetBrains Mono", "Roboto Mono", monospace;
  font-size: 22px;
  font-weight: 700;
  line-height: 26.4px;
  color: var(--text-primary, #142624);
}

.contact-stat-subtitle {
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  color: var(--text-secondary, #506360);
}

/* Tab 1: Overview Body 2-Column */
.contact-overview-body {
  display: grid;
  grid-template-columns: 1fr 378px;
  gap: 16px;
  align-items: start;
}

.contact-info-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.contact-side-col {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Detail Card */
.contact-detail-card {
  background-color: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}

.contact-verification-notice > .contact-btn-secondary {
  margin-top: var(--space-4, 16px);
}

.contact-detail-card-title {
  margin: 0 0 14px 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
  color: var(--text-primary, #142624);
}

.contact-detail-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.contact-detail-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 24px;
}

.contact-detail-label {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--text-secondary, #506360);
  line-height: 21.7px;
}

.contact-detail-val {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary, #142624);
  line-height: 18.2px;
  text-align: right;
}

/* Stepper / Recent Activity Timeline */
.contact-timeline {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 4px;
}

.contact-timeline-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  position: relative;
}

.contact-timeline-indicator {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
  z-index: 2;
}

.contact-timeline-connector {
  width: 1.5px;
  height: 20px;
  background-color: var(--border-default, #cdd6d4);
  margin-left: 11px;
  opacity: 0.7;
}

.contact-timeline-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.contact-timeline-headline {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  color: var(--text-primary, #142624);
}

.contact-timeline-sub {
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: var(--text-tertiary, #6b7b78);
}

/* Invoices Tab Register Table */
.contact-invoices-card {
  background-color: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);
  overflow: hidden;
}

.contact-invoices-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  font-size: 14px;
  line-height: 21.7px;
}

.contact-invoices-count {
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.contact-invoices-meta {
  color: var(--text-secondary, #506360);
}

.contact-invoices-table {
  width: 100%;
  border-collapse: collapse;
}

.contact-invoices-th {
  background-color: var(--surface-secondary, #f4f7f7);
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  padding: 12px 14px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary, #506360);
  text-align: left;
}

.contact-invoices-th.text-right {
  text-align: right;
}

.contact-invoices-th.text-center {
  text-align: center;
}

.contact-invoices-tr {
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  transition: background-color 0.15s ease;
}

.contact-invoices-tr:hover {
  background-color: #fafbfb;
}

.contact-invoices-td {
  padding: 14px;
  font-size: 14px;
  color: var(--text-primary, #142624);
  vertical-align: middle;
}

.contact-invoices-td.text-right {
  text-align: right;
}

.contact-invoices-td.text-center {
  text-align: center;
}

.contact-inv-number {
  color: var(--interactive-default, #0f766e);
  font-weight: 500;
  text-decoration: none;
}

.contact-inv-number:hover {
  text-decoration: underline;
}

/* Payment Status Pills */
.inv-status-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
}

.inv-status-pill.status-paid {
  background-color: var(--success-soft, #edfbf2);
  color: var(--success-default, #15703d);
}

.inv-status-pill.status-overdue {
  background-color: var(--danger-soft, #fef2f1);
  color: var(--danger-text, #a3301f);
}

.inv-status-pill.status-pending {
  background-color: #fffbeb;
  color: #b45309;
}

/* Activity Tab Toolbar & Card */
.contact-activity-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}

.contact-activity-title {
  margin: 0;
  font-size: 22px;
  font-weight: 500;
  line-height: 29.7px;
  letter-spacing: -0.22px;
  color: var(--text-primary, #142624);
}

.contact-activity-sub {
  margin: 2px 0 0 0;
  font-size: 14px;
  color: var(--text-secondary, #506360);
}

.contact-activity-filters {
  display: flex;
  align-items: center;
  gap: 8px;
}

.contact-activity-filter--type {
  width: 160px;
}

.contact-activity-filter--date {
  width: 128px;
}

.contact-activity-filter .quotation-figma-dropdown-trigger {
  font-size: 13px;
  font-weight: 500;
  line-height: 16.9px;
}

.contact-activity-card {
  background-color: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  padding: 24px;
}

.contact-activity-section-title {
  margin: 0 0 14px 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  color: var(--text-primary, #142624);
}

.contact-activity-section-gap {
  height: 24px;
}

.contact-activity-empty {
  display: flex;
  min-height: 120px;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary, #506360);
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}

/* Modal Scrim & Container (Archive & Delete) */
.contact-delete-confirmation .delete-dialog-backdrop {
  background: var(--overlay-default, rgb(0 0 0 / 45%)) !important;
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
}

.contact-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: var(--overlay-default, rgba(10, 22, 20, 0.44));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
}

.contact-modal-dialog {
  background-color: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 20px;
  width: 100%;
  max-width: 440px;
  box-shadow: 0px 6px 8px rgba(14, 26, 32, 0.1),
    0px 1px 1px rgba(14, 26, 32, 0.04);
  overflow: hidden;
  animation: modalFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.contact-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 16px;
  gap: 12px;
}

.contact-modal-title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}

.contact-modal-icon {
  font-size: 22px;
  color: var(--text-secondary, #506360);
  display: flex;
}

.contact-modal-icon.danger {
  color: var(--danger-default, #c23a2b);
}

.contact-modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary, #142624);
}

.contact-modal-close {
  border: none;
  background: transparent;
  color: var(--text-secondary, #506360);
  font-size: 20px;
  cursor: pointer;
  display: flex;
  padding: 4px;
  border-radius: 6px;
  transition: background-color 0.15s ease;
}

.contact-modal-close:hover {
  background-color: var(--surface-tertiary, #e8edec);
}

.contact-modal-divider {
  height: 1px;
  background-color: var(--border-subtle, #dce3e2);
  width: 100%;
}

.contact-modal-body {
  padding: 20px 24px;
}

.contact-modal-body p {
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: var(--text-secondary, #506360);
}

.contact-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px 24px;
}

.contact-modal-btn-cancel {
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.contact-modal-btn-cancel:hover {
  background-color: var(--surface-tertiary, #e8edec);
  border-color: var(--border-strong, #8b9996);
  color: var(--text-primary, #142624);
}

.contact-modal-btn-confirm,
.contact-modal-btn-confirm:link,
.contact-modal-btn-confirm:visited {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  border: none;
  background: var(--interactive-default, #0f766e);
  color: #ffffff !important;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.contact-modal-btn-confirm:hover {
  background-color: var(--interactive-hover, #0a655f);
  color: #ffffff !important;
}

.contact-modal-dialog[aria-busy="true"] button:disabled {
  pointer-events: none;
  cursor: wait;
}

.contact-modal-btn-confirm:active {
  background-color: var(--interactive-pressed, #084f4b);
  color: #ffffff !important;
}

.contact-modal-btn-confirm.danger {
  background-color: var(--danger-default, #c23a2b);
}

.contact-modal-btn-confirm.danger:hover {
  background-color: #a3301f;
  color: #ffffff !important;
}

/* Dark mode modal buttons */
.contact-details-page.dark .contact-modal-btn-confirm:not(.danger),
.contact-details-page[data-theme="dark"]
  .contact-modal-btn-confirm:not(.danger) {
  background-color: var(--interactive-default, #43a79c);
  color: #101113 !important;
  font-weight: 600;
}

.contact-details-page.dark .contact-modal-btn-confirm:not(.danger):hover,
.contact-details-page[data-theme="dark"]
  .contact-modal-btn-confirm:not(.danger):hover {
  background-color: var(--interactive-hover, #83c7be);
  color: #101113 !important;
}

.contact-details-page.dark .contact-modal-btn-confirm.danger:hover,
.contact-details-page[data-theme="dark"]
  .contact-modal-btn-confirm.danger:hover {
  background-color: #4a2b2c;
  color: #f3aaa4 !important;
}

.contact-details-page.dark .contact-modal-btn-cancel {
  background-color: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.contact-details-page.dark .contact-modal-btn-cancel:hover,
.contact-details-page[data-theme="dark"] .contact-modal-btn-cancel:hover {
  background-color: var(--surface-tertiary, #2b2f35);
  border-color: var(--border-strong, #69727e);
  color: var(--text-primary, #f2f3f5);
}

/* Save Success Toast */
.contact-toast-container {
  position: fixed;
  top: 84px;
  right: 32px;
  z-index: 1050;
  animation: toastSlideDown 0.25s ease-out;
}

@keyframes toastSlideDown {
  from {
    opacity: 0;
    transform: translateY(-12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.contact-toast-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background-color: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  box-shadow: 0px 6px 8px rgba(14, 26, 32, 0.1),
    0px 1px 1px rgba(14, 26, 32, 0.04);
  min-width: 320px;
  max-width: 440px;
}

.contact-toast-accent {
  width: 3px;
  height: 24px;
  background-color: var(--success-default, #15703d);
  border-radius: 2px;
  flex-shrink: 0;
}

.contact-toast-icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: var(--success-soft, #edfbf2);
  color: var(--success-default, #15703d);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}

.contact-toast-msg {
  flex: 1 1;
  font-size: 14px;
  line-height: 20px;
  color: var(--text-primary, #142624);
  margin: 0;
}

.contact-toast-close {
  border: none;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
  display: flex;
  padding: 4px;
  border-radius: 6px;
}

.contact-toast-close:hover {
  background-color: var(--surface-tertiary, #e8edec);
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .contact-details-page .dashboard-main {
    margin-left: 0;
  }
  .contact-stat-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .contact-overview-body {
    grid-template-columns: 1fr;
  }
  .contact-side-col {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .contact-details-content {
    padding: 20px 16px 32px;
  }

  .contact-details-title-row {
    align-items: flex-start;
    flex-direction: column;
  }

  .contact-details-title {
    font-size: 20px;
    line-height: 26px;
    letter-spacing: -0.2px;
  }

  .contact-details-actions {
    width: 100%;
  }

  .contact-details-actions > .contact-btn-primary,
  .contact-details-actions > .contact-btn-secondary {
    flex: 1 1;
  }

  .contact-details-tabs {
    overflow-x: auto;
    scrollbar-width: none;
  }

  .contact-details-tabs::-webkit-scrollbar {
    display: none;
  }

  .contact-activity-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .contact-activity-filters,
  .contact-activity-filter--type,
  .contact-activity-filter--date {
    width: 100%;
  }

  .contact-detail-card {
    padding: 20px;
  }

  .contact-detail-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }

  .contact-modal-overlay {
    align-items: flex-end;
    padding: 64px 0 0;
    background: var(--overlay-default, rgba(0, 0, 0, 0.6));
  }

  .contact-modal-dialog {
    position: relative;
    max-width: none;
    min-height: 350px;
    border-radius: 20px 20px 0 0;
    animation: contactSheetIn 0.2s ease-out;
  }

  .contact-modal-dialog::before {
    content: "";
    position: absolute;
    top: 8px;
    left: 50%;
    width: 40px;
    height: 4px;
    border-radius: 999px;
    background: var(--border-subtle, #dce3e2);
    transform: translateX(-50%);
  }

  .contact-modal-header {
    min-height: 80px;
    padding: 20px 24px 0;
    border-bottom: 1px solid var(--border-subtle, #dce3e2);
  }

  .contact-modal-title {
    font-size: 16px;
    font-weight: 500;
    line-height: 22.4px;
    letter-spacing: -0.08px;
  }

  .contact-modal-divider {
    display: none;
  }

  .contact-modal-body {
    min-height: 102px;
    padding: 18px 24px;
  }

  .contact-modal-body p {
    font-size: 13px;
    line-height: 20.2px;
  }

  .contact-modal-footer {
    flex-direction: column;
    gap: 12px;
    padding: 16px 24px 28px;
    border-top: 1px solid var(--border-subtle, #dce3e2);
  }

  .contact-modal-btn-cancel,
  .contact-modal-btn-confirm {
    width: 100%;
    height: 44px;
  }
}

@keyframes contactSheetIn {
  from {
    opacity: 0;
    transform: translateY(32px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Contacts/contactDetails.css"],"names":[],"mappings":"AAAA,+IAA+I;;AAE/I;EACE,aAAa;EACb,iBAAiB;EACjB,4CAA4C;EAC5C,mCAAmC;EACnC;cACY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,SAAS;EACT,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,uCAAuC;EACvC,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,kDAAkD;EAClD,qCAAqC;AACvC;;AAEA;EACE,+CAA+C;AACjD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gDAAgD;EAChD,iDAAiD;EACjD,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gEAAgE;AAClE;;AAEA;EACE,kDAAkD;EAClD,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;EACrD,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;;EAEE,qDAAqD;EACrD,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;;EAEE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,iDAAiD;EACjD,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;;EAEE,kDAAkD;EAClD,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,+CAA+C;EAC/C,mBAAmB;EACnB;sCACoC;EACpC,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,qBAAqB;EACrB,sDAAsD;EACtD,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,8BAA8B;EAE9B,kEAAkE;AACpE;;AAEA;EACE,mEAAwF;AAC1F;;AAEA;EACE,mEAA8E;AAChF;;AAEA;EACE,mEAAqF;AACvF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,uDAAuD;EACvD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kDAAkD;EAClD,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gDAAgD;EAChD,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA,gCAAgC;AAChC;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,mBAAmB;EACnB,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sDAAsD;EACtD,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,sDAAsD;EACtD,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;EACtD,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,+DAA+D;EAC/D,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,gEAAgE;EAChE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB;sCACoC;EACpC,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,+CAA+C;EAC/C,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gDAAgD;EAChD,2CAA2C;EAC3C,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;EAClD,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,+CAA+C;EAC/C,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;;;EAGE,qDAAqD;EACrD,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;EAGE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,iDAAiD;EACjD,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;;EAEE,kDAAkD;EAClD,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iDAAiD;EACjD,+CAA+C;EAC/C,mBAAmB;EACnB;sCACoC;EACpC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iDAAiD;EACjD,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,iBAAiB;EACjB,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;AACpD;;AAEA,2BAA2B;AAC3B;EACE;IACE,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,SAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,sDAAsD;EACxD;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,uCAAuC;EACzC;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,yCAAyC;IACzC,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,sDAAsD;EACxD;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,mDAAmD;EACrD;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* Contact Details Styling - Pixel-Perfect Figma Implementation (1564:164698, 1587:89228, 1581:149550, 1591:150629, 1591:150817, 1591:151005) */\n\n.contact-details-page {\n  display: flex;\n  min-height: 100vh;\n  background-color: var(--bg-primary, #f4f7f7);\n  color: var(--text-primary, #142624);\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    sans-serif;\n  box-sizing: border-box;\n}\n\n.contact-details-page .dashboard-main {\n  flex: 1;\n  min-width: 0;\n  margin-left: 256px;\n  display: flex;\n  flex-direction: column;\n}\n\n.contact-details-content {\n  padding: 32px 32px 48px;\n  max-width: 100%;\n  width: 100%;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n/* Header & Back Link */\n.contact-details-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.contact-details-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 12px;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--interactive-default, #0f766e);\n  font-size: 13px;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n  width: fit-content;\n}\n\n.contact-details-back-btn:hover {\n  background-color: var(--interactive-soft, #f0f8f7);\n}\n\n.contact-details-back-btn svg {\n  font-size: 16px;\n}\n\n.contact-details-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.contact-details-identity {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.contact-details-title {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n  color: var(--text-primary, #142624);\n}\n\n.contact-details-badges {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.contact-badge-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: normal;\n  background-color: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n\n.contact-badge-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: var(--interactive-default, #0f766e);\n}\n\n.contact-badge-pill.status-archived {\n  background-color: var(--surface-tertiary, #e8edec);\n  color: var(--text-secondary, #506360);\n}\n\n.contact-badge-pill.status-archived .contact-badge-dot {\n  background-color: var(--text-disabled, #8a9896);\n}\n\n/* Header Actions */\n.contact-details-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n}\n\n.contact-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 10px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  background-color: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.contact-btn-secondary:hover {\n  background-color: var(--surface-tertiary, #e8edec);\n  border-color: var(--border-strong, #8b9996);\n  color: var(--text-primary, #142624);\n}\n\n.contact-btn-primary,\n.contact-btn-primary:link,\n.contact-btn-primary:visited {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 10px;\n  border: none;\n  background-color: var(--interactive-default, #0f766e);\n  color: #ffffff !important;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background-color 0.15s ease;\n}\n\n.contact-btn-primary:hover {\n  background-color: var(--interactive-hover, #0a655f);\n  color: #ffffff !important;\n}\n\n.contact-btn-primary:active {\n  background-color: var(--interactive-pressed, #084f4b);\n  color: #ffffff !important;\n}\n\n.contact-btn-primary svg {\n  color: #ffffff !important;\n  stroke: #ffffff !important;\n}\n\n/* Dark mode button themes */\n.contact-details-page.dark .contact-btn-primary,\n.contact-details-page[data-theme=\"dark\"] .contact-btn-primary {\n  background-color: var(--interactive-default, #43a79c);\n  color: #101113 !important;\n  font-weight: 600;\n}\n\n.contact-details-page.dark .contact-btn-primary svg,\n.contact-details-page[data-theme=\"dark\"] .contact-btn-primary svg {\n  color: #101113 !important;\n  stroke: #101113 !important;\n}\n\n.contact-details-page.dark .contact-btn-primary:hover,\n.contact-details-page[data-theme=\"dark\"] .contact-btn-primary:hover {\n  background-color: var(--interactive-hover, #83c7be);\n  color: #101113 !important;\n}\n\n.contact-details-page.dark .contact-btn-primary:active,\n.contact-details-page[data-theme=\"dark\"] .contact-btn-primary:active {\n  background-color: var(--interactive-pressed, #b6ded8);\n  color: #101113 !important;\n}\n\n.contact-details-page.dark .contact-btn-secondary {\n  background-color: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.contact-details-page.dark .contact-btn-secondary:hover,\n.contact-details-page[data-theme=\"dark\"] .contact-btn-secondary:hover {\n  background-color: var(--surface-tertiary, #2b2f35);\n  border-color: var(--border-strong, #69727e);\n  color: var(--text-primary, #f2f3f5);\n}\n\n/* More Dropdown Menu */\n.contact-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 120px;\n  min-width: 200px;\n  background: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  z-index: 50;\n  overflow: hidden;\n  padding: 4px 0;\n}\n\n.contact-dropdown-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border: none;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  font-weight: 400;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.contact-dropdown-item:hover {\n  background-color: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n\n.contact-dropdown-item.danger:hover {\n  background-color: var(--danger-soft, #fef2f1);\n  color: var(--danger-default, #c23a2b);\n}\n\n/* Tabs */\n.contact-details-tabs {\n  display: flex;\n  align-items: flex-end;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  margin-bottom: 24px;\n  gap: 4px;\n}\n\n.contact-tab-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 16px;\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.15s ease;\n}\n\n.contact-tab-btn:hover {\n  color: var(--text-primary, #142624);\n}\n\n.contact-tab-btn.active {\n  color: var(--interactive-default, #0f766e);\n  font-weight: 500;\n  border-bottom: 2px solid var(--interactive-default, #0f766e);\n}\n\n/* Stat Cards (3 Cards Row) */\n.contact-stat-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.contact-stat-card {\n  background-color: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  padding: 24px;\n  min-height: 154px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-sizing: border-box;\n}\n\n.contact-stat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.contact-stat-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n  color: var(--text-primary, #142624);\n}\n\n.contact-stat-icon {\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n  color: var(--interactive-default, #0f766e);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.contact-stat-icon svg {\n  width: 20px;\n  height: 20px;\n  display: block;\n  stroke: currentColor;\n}\n\n.contact-stat-icon--figma::before {\n  content: \"\";\n  display: block;\n  width: 20px;\n  height: 20px;\n  background-color: currentColor;\n  -webkit-mask: var(--contact-stat-icon-source) center / 20px 20px no-repeat;\n  mask: var(--contact-stat-icon-source) center / 20px 20px no-repeat;\n}\n\n.contact-stat-icon--total-invoiced {\n  --contact-stat-icon-source: url(\"../../assets/icons/contact-details/total-invoiced.svg\");\n}\n\n.contact-stat-icon--paid {\n  --contact-stat-icon-source: url(\"../../assets/icons/contact-details/paid.svg\");\n}\n\n.contact-stat-icon--outstanding {\n  --contact-stat-icon-source: url(\"../../assets/icons/contact-details/outstanding.svg\");\n}\n\n.contact-stat-headline {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.contact-stat-amount {\n  margin: 0;\n  font-family: \"JetBrains Mono\", \"Roboto Mono\", monospace;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 26.4px;\n  color: var(--text-primary, #142624);\n}\n\n.contact-stat-subtitle {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  color: var(--text-secondary, #506360);\n}\n\n/* Tab 1: Overview Body 2-Column */\n.contact-overview-body {\n  display: grid;\n  grid-template-columns: 1fr 378px;\n  gap: 16px;\n  align-items: start;\n}\n\n.contact-info-col {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.contact-side-col {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Detail Card */\n.contact-detail-card {\n  background-color: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.contact-verification-notice > .contact-btn-secondary {\n  margin-top: var(--space-4, 16px);\n}\n\n.contact-detail-card-title {\n  margin: 0 0 14px 0;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n  color: var(--text-primary, #142624);\n}\n\n.contact-detail-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.contact-detail-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 24px;\n}\n\n.contact-detail-label {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--text-secondary, #506360);\n  line-height: 21.7px;\n}\n\n.contact-detail-val {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n  line-height: 18.2px;\n  text-align: right;\n}\n\n/* Stepper / Recent Activity Timeline */\n.contact-timeline {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin-top: 4px;\n}\n\n.contact-timeline-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  position: relative;\n}\n\n.contact-timeline-indicator {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  flex-shrink: 0;\n  z-index: 2;\n}\n\n.contact-timeline-connector {\n  width: 1.5px;\n  height: 20px;\n  background-color: var(--border-default, #cdd6d4);\n  margin-left: 11px;\n  opacity: 0.7;\n}\n\n.contact-timeline-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.contact-timeline-headline {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  color: var(--text-primary, #142624);\n}\n\n.contact-timeline-sub {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20px;\n  color: var(--text-tertiary, #6b7b78);\n}\n\n/* Invoices Tab Register Table */\n.contact-invoices-card {\n  background-color: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);\n  overflow: hidden;\n}\n\n.contact-invoices-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n\n.contact-invoices-count {\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.contact-invoices-meta {\n  color: var(--text-secondary, #506360);\n}\n\n.contact-invoices-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.contact-invoices-th {\n  background-color: var(--surface-secondary, #f4f7f7);\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  padding: 12px 14px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-secondary, #506360);\n  text-align: left;\n}\n\n.contact-invoices-th.text-right {\n  text-align: right;\n}\n\n.contact-invoices-th.text-center {\n  text-align: center;\n}\n\n.contact-invoices-tr {\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  transition: background-color 0.15s ease;\n}\n\n.contact-invoices-tr:hover {\n  background-color: #fafbfb;\n}\n\n.contact-invoices-td {\n  padding: 14px;\n  font-size: 14px;\n  color: var(--text-primary, #142624);\n  vertical-align: middle;\n}\n\n.contact-invoices-td.text-right {\n  text-align: right;\n}\n\n.contact-invoices-td.text-center {\n  text-align: center;\n}\n\n.contact-inv-number {\n  color: var(--interactive-default, #0f766e);\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.contact-inv-number:hover {\n  text-decoration: underline;\n}\n\n/* Payment Status Pills */\n.inv-status-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 18px;\n}\n\n.inv-status-pill.status-paid {\n  background-color: var(--success-soft, #edfbf2);\n  color: var(--success-default, #15703d);\n}\n\n.inv-status-pill.status-overdue {\n  background-color: var(--danger-soft, #fef2f1);\n  color: var(--danger-text, #a3301f);\n}\n\n.inv-status-pill.status-pending {\n  background-color: #fffbeb;\n  color: #b45309;\n}\n\n/* Activity Tab Toolbar & Card */\n.contact-activity-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.contact-activity-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 500;\n  line-height: 29.7px;\n  letter-spacing: -0.22px;\n  color: var(--text-primary, #142624);\n}\n\n.contact-activity-sub {\n  margin: 2px 0 0 0;\n  font-size: 14px;\n  color: var(--text-secondary, #506360);\n}\n\n.contact-activity-filters {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.contact-activity-filter--type {\n  width: 160px;\n}\n\n.contact-activity-filter--date {\n  width: 128px;\n}\n\n.contact-activity-filter .quotation-figma-dropdown-trigger {\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16.9px;\n}\n\n.contact-activity-card {\n  background-color: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  padding: 24px;\n}\n\n.contact-activity-section-title {\n  margin: 0 0 14px 0;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  color: var(--text-primary, #142624);\n}\n\n.contact-activity-section-gap {\n  height: 24px;\n}\n\n.contact-activity-empty {\n  display: flex;\n  min-height: 120px;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n}\n\n/* Modal Scrim & Container (Archive & Delete) */\n.contact-delete-confirmation .delete-dialog-backdrop {\n  background: var(--overlay-default, rgb(0 0 0 / 45%)) !important;\n  backdrop-filter: blur(3px);\n  -webkit-backdrop-filter: blur(3px);\n}\n\n.contact-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: var(--overlay-default, rgba(10, 22, 20, 0.44));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 16px;\n}\n\n.contact-modal-dialog {\n  background-color: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 20px;\n  width: 100%;\n  max-width: 440px;\n  box-shadow: 0px 6px 8px rgba(14, 26, 32, 0.1),\n    0px 1px 1px rgba(14, 26, 32, 0.04);\n  overflow: hidden;\n  animation: modalFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.contact-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 24px 16px;\n  gap: 12px;\n}\n\n.contact-modal-title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.contact-modal-icon {\n  font-size: 22px;\n  color: var(--text-secondary, #506360);\n  display: flex;\n}\n\n.contact-modal-icon.danger {\n  color: var(--danger-default, #c23a2b);\n}\n\n.contact-modal-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary, #142624);\n}\n\n.contact-modal-close {\n  border: none;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  font-size: 20px;\n  cursor: pointer;\n  display: flex;\n  padding: 4px;\n  border-radius: 6px;\n  transition: background-color 0.15s ease;\n}\n\n.contact-modal-close:hover {\n  background-color: var(--surface-tertiary, #e8edec);\n}\n\n.contact-modal-divider {\n  height: 1px;\n  background-color: var(--border-subtle, #dce3e2);\n  width: 100%;\n}\n\n.contact-modal-body {\n  padding: 20px 24px;\n}\n\n.contact-modal-body p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--text-secondary, #506360);\n}\n\n.contact-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px 24px;\n}\n\n.contact-modal-btn-cancel {\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 10px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.contact-modal-btn-cancel:hover {\n  background-color: var(--surface-tertiary, #e8edec);\n  border-color: var(--border-strong, #8b9996);\n  color: var(--text-primary, #142624);\n}\n\n.contact-modal-btn-confirm,\n.contact-modal-btn-confirm:link,\n.contact-modal-btn-confirm:visited {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 10px;\n  border: none;\n  background: var(--interactive-default, #0f766e);\n  color: #ffffff !important;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.contact-modal-btn-confirm:hover {\n  background-color: var(--interactive-hover, #0a655f);\n  color: #ffffff !important;\n}\n\n.contact-modal-dialog[aria-busy=\"true\"] button:disabled {\n  pointer-events: none;\n  cursor: wait;\n}\n\n.contact-modal-btn-confirm:active {\n  background-color: var(--interactive-pressed, #084f4b);\n  color: #ffffff !important;\n}\n\n.contact-modal-btn-confirm.danger {\n  background-color: var(--danger-default, #c23a2b);\n}\n\n.contact-modal-btn-confirm.danger:hover {\n  background-color: #a3301f;\n  color: #ffffff !important;\n}\n\n/* Dark mode modal buttons */\n.contact-details-page.dark .contact-modal-btn-confirm:not(.danger),\n.contact-details-page[data-theme=\"dark\"]\n  .contact-modal-btn-confirm:not(.danger) {\n  background-color: var(--interactive-default, #43a79c);\n  color: #101113 !important;\n  font-weight: 600;\n}\n\n.contact-details-page.dark .contact-modal-btn-confirm:not(.danger):hover,\n.contact-details-page[data-theme=\"dark\"]\n  .contact-modal-btn-confirm:not(.danger):hover {\n  background-color: var(--interactive-hover, #83c7be);\n  color: #101113 !important;\n}\n\n.contact-details-page.dark .contact-modal-btn-confirm.danger:hover,\n.contact-details-page[data-theme=\"dark\"]\n  .contact-modal-btn-confirm.danger:hover {\n  background-color: #4a2b2c;\n  color: #f3aaa4 !important;\n}\n\n.contact-details-page.dark .contact-modal-btn-cancel {\n  background-color: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.contact-details-page.dark .contact-modal-btn-cancel:hover,\n.contact-details-page[data-theme=\"dark\"] .contact-modal-btn-cancel:hover {\n  background-color: var(--surface-tertiary, #2b2f35);\n  border-color: var(--border-strong, #69727e);\n  color: var(--text-primary, #f2f3f5);\n}\n\n/* Save Success Toast */\n.contact-toast-container {\n  position: fixed;\n  top: 84px;\n  right: 32px;\n  z-index: 1050;\n  animation: toastSlideDown 0.25s ease-out;\n}\n\n@keyframes toastSlideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.contact-toast-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  background-color: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  box-shadow: 0px 6px 8px rgba(14, 26, 32, 0.1),\n    0px 1px 1px rgba(14, 26, 32, 0.04);\n  min-width: 320px;\n  max-width: 440px;\n}\n\n.contact-toast-accent {\n  width: 3px;\n  height: 24px;\n  background-color: var(--success-default, #15703d);\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n\n.contact-toast-icon-wrap {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background-color: var(--success-soft, #edfbf2);\n  color: var(--success-default, #15703d);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.contact-toast-msg {\n  flex: 1;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--text-primary, #142624);\n  margin: 0;\n}\n\n.contact-toast-close {\n  border: none;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n  display: flex;\n  padding: 4px;\n  border-radius: 6px;\n}\n\n.contact-toast-close:hover {\n  background-color: var(--surface-tertiary, #e8edec);\n}\n\n/* Responsive adjustments */\n@media (max-width: 1024px) {\n  .contact-details-page .dashboard-main {\n    margin-left: 0;\n  }\n  .contact-stat-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  .contact-overview-body {\n    grid-template-columns: 1fr;\n  }\n  .contact-side-col {\n    width: 100%;\n  }\n}\n\n@media (max-width: 600px) {\n  .contact-details-content {\n    padding: 20px 16px 32px;\n  }\n\n  .contact-details-title-row {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .contact-details-title {\n    font-size: 20px;\n    line-height: 26px;\n    letter-spacing: -0.2px;\n  }\n\n  .contact-details-actions {\n    width: 100%;\n  }\n\n  .contact-details-actions > .contact-btn-primary,\n  .contact-details-actions > .contact-btn-secondary {\n    flex: 1;\n  }\n\n  .contact-details-tabs {\n    overflow-x: auto;\n    scrollbar-width: none;\n  }\n\n  .contact-details-tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .contact-activity-toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .contact-activity-filters,\n  .contact-activity-filter--type,\n  .contact-activity-filter--date {\n    width: 100%;\n  }\n\n  .contact-detail-card {\n    padding: 20px;\n  }\n\n  .contact-detail-row {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .contact-modal-overlay {\n    align-items: flex-end;\n    padding: 64px 0 0;\n    background: var(--overlay-default, rgba(0, 0, 0, 0.6));\n  }\n\n  .contact-modal-dialog {\n    position: relative;\n    max-width: none;\n    min-height: 350px;\n    border-radius: 20px 20px 0 0;\n    animation: contactSheetIn 0.2s ease-out;\n  }\n\n  .contact-modal-dialog::before {\n    content: \"\";\n    position: absolute;\n    top: 8px;\n    left: 50%;\n    width: 40px;\n    height: 4px;\n    border-radius: 999px;\n    background: var(--border-subtle, #dce3e2);\n    transform: translateX(-50%);\n  }\n\n  .contact-modal-header {\n    min-height: 80px;\n    padding: 20px 24px 0;\n    border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  }\n\n  .contact-modal-title {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 22.4px;\n    letter-spacing: -0.08px;\n  }\n\n  .contact-modal-divider {\n    display: none;\n  }\n\n  .contact-modal-body {\n    min-height: 102px;\n    padding: 18px 24px;\n  }\n\n  .contact-modal-body p {\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n\n  .contact-modal-footer {\n    flex-direction: column;\n    gap: 12px;\n    padding: 16px 24px 28px;\n    border-top: 1px solid var(--border-subtle, #dce3e2);\n  }\n\n  .contact-modal-btn-cancel,\n  .contact-modal-btn-confirm {\n    width: 100%;\n    height: 44px;\n  }\n}\n\n@keyframes contactSheetIn {\n  from {\n    opacity: 0;\n    transform: translateY(32px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
